module.exports = {
	extends: [
		'/',
		'templates',
		'core',
		'documents',
		'table',
		'table'
	],

	config: {
		// inline: false
	},

	methods: {

		onPrepareDone: function(storage){
			this.resourceData.data = ((storage.request || {}).documentData || {}).data || []
			this.resourceData.initialized = false;
			this.sanitizeResources(storage)
		},

		// sanitizeResourceFilters: function(storage, resourceFilters, actionKey, areBaseTableResourceFilters){
		// 	// override sanitizeResourceFilters of extended component only!
		// },

		sanitizeEntity: function(refEntity, refPrevEntity){
			refEntity.attributes = refEntity.attributes || {}
			refEntity.meta = refEntity.meta || {}
			const projectTermID = ((refEntity.attributes || {}).projectTerm || {}).projectTermID
			const prevProjectTermID = (((refPrevEntity || {}).attributes || {}).projectTerm || {}).projectTermID

			refEntity.meta.hasGroupRow =
				!refPrevEntity ||
				(projectTermID && prevProjectTermID && projectTermID != prevProjectTermID) ||
				(!projectTermID && prevProjectTermID) ||
				(projectTermID && !prevProjectTermID)
		},

		showEdit: function(rowID, rowData, buttonMode){
			// prevent actions in this table
		},
	},
}